import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import ToastMessage from "../../utils/mui/righttoptoast";
import api from "../../api/api";
import { Backdrop, CircularProgress } from "@mui/material";

const AortaUltraSound = ({ ismodal, setIsmodal, data }) => {
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("error");
  const [isLoading, setIsLoading] = useState(false);
  const [providerList, setProviderList] = useState([]);

  const formattedDOB = dayjs(data?.dob).format("DD-MM-YYYY");
  const age = dayjs().diff(dayjs(data?.dob), "year");

  const [formData, setFormData] = useState({
    provider: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    history: "",
    impression: "",
    signature: "",
  });

  const [measurements, setMeasurements] = useState({
    aortaSag: { prox: "", mid: "", distal: "" },
    aortaTrv: { prox: "", mid: "", distal: "" },
    iliacsSag: { prox: "", mid: "", distal: "" },
    iliacsTrv: { prox: "", mid: "", distal: "" },
  });

  const practiseid = window.getPracticeId();

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };
useEffect(() => {
  console.log("🔄 useEffect triggered");
  console.log("formData.provider =", formData.provider);
  console.log("providerList =", providerList);
  console.log("data?.linked_provider =", data?.linked_provider);

  if (!formData.provider && providerList.length > 0) {
    const providerNames = providerList.map(x => x.providername);
    console.log("providerNames array =", providerNames);

    if (data?.linked_provider && providerNames.includes(data.linked_provider)) {
      console.log("✅ Setting provider from linked_provider:", data.linked_provider);
      handleChange("provider", data.linked_provider);
    } else if (providerList.length > 0) {
      console.log("✅ Setting provider from first provider:", providerList[0].providername);
      handleChange("provider", providerList[0].providername);
    }
  } else {
    console.log("⏩ Skipped setting provider (already set or no providers).");
  }
}, [providerList, data, formData.provider]);

  const handleMeasurementChange = (section, field, value) => {
    if (/^\d*\.?\d*$/.test(value)) {
      setMeasurements((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [field]: value,
        },
      }));
    }
  };

  useEffect(() => {
    if (ismodal) getProviders();
  }, [ismodal]);

  const getProviders = async () => {
    try {
      const response = await api.get(`/v1/${practiseid}/providers`);
      if (response.status === 200 && Array.isArray(response.data)) {
        setProviderList(response.data);
      }
    } catch (error) {
      console.error("Error fetching providers:", error);
      setToastMessage("Failed to load providers");
      setToastSeverity("error");
      setOpenToast(true);
    }
  };

  const validateForm = () => {
    const errors = [];
    if (!formData.provider) errors.push("Provider is required.");
    if (!formData.examDate) errors.push("Exam Date is required.");
    if (!formData.history.trim()) errors.push("Patient History is required.");
    if (!formData.impression.trim()) errors.push("Impression is required.");
    if (!formData.signature.trim()) errors.push("Signature is required.");
    return errors;
  };

  const handleSave = async () => {
    const errors = validateForm();
    if (errors.length > 0) {
      setToastMessage(errors[0]);
      setToastSeverity("error");
      setOpenToast(true);
      return;
    }

    try {
      setIsLoading(true);
      const selectedProvider = providerList.find(
        (p) => p.providername === formData.provider
      );
      const patientDetails = {
        patientid: data.patientid,
        appointmentid: data.appointmentid,
        firstname: data.firstname,
        lastname: data.lastname,
        providername: formData.provider,
        providerid: selectedProvider?.providerid,
        pat_name: `${data?.firstname} ${data?.lastname}`,
          pat_dob: data?.dob,
        dob: formattedDOB,
        age,
        gender: data.gender === "M" ? "Male" : "Female",
      };

      const payload = {
        ...formData,
        ...measurements,
        ...patientDetails,
      };

      const user = await api.get("/auth/me");
      const [year, month, day] = formData.examDate.split("-");
      const formattedDate = `${month}/${day}/${year}`;

      const response = await api.post(
        `/v1/${practiseid}/patient/${data.patientid}/imaging/insert-db`,
        {
          Worksheet_Type: "AORTA_ULTRASOUND",
          createdby: user?.username || "",
           "appurl": window.location.origin,
          // appurl: "",
          Exam_Date: formattedDate,
          data: payload,
        }
      );

      if (response.status === 200) {
        await api.post(
          `/v1/${practiseid}/patient/${data.patientid}/imaging/generate-pdf`,
          {
            filename: response?.data?.filename,
             "appurl": window.location.origin,
            // appurl: "",
            worksheet_type: "AORTA_ULTRASOUND",
            exam_date: formattedDate,
          }
        );
        setToastMessage("Form Submitted Successfully");
        setToastSeverity("success");
        setOpenToast(true);
        setTimeout(() => setIsmodal(false), 1000);
      } else {
        setToastMessage(response.message);
        setToastSeverity("info");
        setOpenToast(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!ismodal) return null;

  const renderMeasurementInputs = (label, key) => (
    <div className="mt-4">
      <h4 className="font-semibold text-sm mb-2">{label}</h4>
      <div className="grid grid-cols-3 gap-4">
        {["prox", "mid", "distal"].map((field) => (
          <div key={`${key}-${field}`}>
            <label className="block text-sm font-medium capitalize">{field}</label>
            <input
              type="text"
              inputMode="decimal"
              className="w-full border rounded px-2 py-1"
              placeholder={field.toUpperCase()}
              value={measurements[key][field]}
              onChange={(e) =>
                handleMeasurementChange(key, field, e.target.value)
              }
            />
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50 overflow-y-auto min-h-screen px-2 py-6">
      <div className="w-full max-w-4xl text-start bg-white rounded-lg p-6 shadow-xl relative">
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-semibold">AORTA ULTRASOUND</h2>
          <button
            onClick={() => setIsmodal(false)}
            className="text-xl font-bold text-gray-500 hover:text-black"
          >
            ×
          </button>
        </div>
        <hr className="mb-4 border-gray-300" />

        <div className="flex items-center space-x-4 mb-4">
          <img
            src={`/cloud-assets/chim/public/assets/images/profilepictures/${data.patientid}.png`}
            alt="User"
            className="w-16 h-full max-h-28 rounded-md object-cover"
          />
          <div className="space-y-1">
            <div className="text-white bg-violet-500 rounded-lg px-1.5 py-0.5 text-xs font-medium inline-block">
     #{data?.patientid}
            </div>
            <div className="text-base font-semibold">
              {data?.firstname + " " + data?.lastname}
            </div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Date of Birth:</span>{" "}
              {formattedDOB}
            </div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Age:</span> {age} |{" "}
              <span className="font-semibold">Gender:</span>{" "}
              {data?.gender === "M" ? "Male" : "Female"}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Providers</label>
            <select
              className="w-full border rounded px-2 py-1"
              value={formData.provider}
              onChange={(e) => handleChange("provider", e.target.value)}
            >
              <option value="">Select Provider</option>
              {providerList.map((provider) => (
                <option key={provider.id} value={provider.providername}>
                  {provider.providername}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Exam Date</label>
            <input
              type="date"
              className="w-full border rounded px-2 py-1"
              value={formData.examDate}
              onChange={(e) => handleChange("examDate", e.target.value)}
            />
          </div>
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Patient History</label>
          <textarea
            placeholder="Enter Patient History here..."
            className="w-full border rounded px-2 py-1 mt-1"
            rows={3}
            value={formData.history}
            onChange={(e) => handleChange("history", e.target.value)}
          />
        </div>

        {/* Direct Inputs */}
        {renderMeasurementInputs("AORTA SAG", "aortaSag")}
        {renderMeasurementInputs("AORTA TRV", "aortaTrv")}
        {renderMeasurementInputs("ILIACS SAG", "iliacsSag")}
        {renderMeasurementInputs("ILIACS TRV", "iliacsTrv")}

        <div className="mt-4">
          <label className="block text-sm font-medium">
            Sonographer's Impression
          </label>
          <textarea
            placeholder="Enter Sonographer's Impression here..."
            className="w-full border rounded px-2 py-1 mt-1"
            rows={3}
            value={formData.impression}
            onChange={(e) => handleChange("impression", e.target.value)}
          />
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Signature</label>
          <input
            className="w-full border rounded px-2 py-1 mt-1"
            placeholder="Signature"
            value={formData.signature}
            onChange={(e) => handleChange("signature", e.target.value)}
          />
        </div>

        <div className="flex justify-end mt-6">
          <button
            onClick={handleSave}
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
          >
            Save
          </button>
        </div>
      </div>

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={() => setOpenToast(false)}
      />
    </div>
  );
};

export default AortaUltraSound;
